/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { ProdAdPlacementCardPreview } from './prod-ad-preview-card';

type AdsCustomMessageProps = {
  longHeadline: string,
  description: string,
  displayUrl: string,
  finalUrl: string,
  imageSrc: string,
  lowPrice: number,
  price: number,
  priceCurrencySymbol: string,
  shippingDescription: string,
};

type CarouselProps = {
  children: React.ReactNode[],
};

const prodAdPreviewStyle = {
  adsLabel: {
    border: '1px solid #ddd',
    padding: '0 2px',
    fontSize: 11,
    fontWeight: 600,
    lineHeight: 1,
    borderRadius: 6,
    margin: '0 4px 0 0',
    display: 'inline',
    color: '#767676',
    opacity: '100%',
    position: 'static',
    maxHeight: 16,
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    '& .feed-back': {
      marginTop: 235,
      marginLeft: 15,
    },
  },
  carouselContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& .carousel-wrapper': {
      display: 'flex',
      width: '100%',
      position: 'relative',
      '& .carousel-content-wrapper': {
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        '& .carousel-content': {
          width: '100%',
          flexShrink: 0,
          flexGrow: 1,
          display: 'flex',
          transition: 'all 250ms linear',
          MsOverflowStyle: 'none',
          scrollbarWidth: 'none',
        },
      },
      '& .left-arrow': {
        position: 'absolute',
        zIndex: 1,
        top: '50%',
        transform: 'translateY(-50%)',
        width: '48px',
        height: '48px',
        borderRadius: '24px',
        backgroundColor: 'white',
        border: '1px solid #ddd',
        left: '24px',
        cursor: 'pointer',
      },
      '& .left-arrow:hover': {
        scale: '1.1',
      },
      '& .right-arrow': {
        position: 'absolute',
        zIndex: 1,
        top: '50%',
        transform: 'translateY(-50%)',
        width: '48px',
        height: '48px',
        borderRadius: '24px',
        backgroundColor: 'white',
        border: '1px solid #ddd',
        right: '24px',
        cursor: 'pointer',
      },
      '& .right-arrow:hover': {
        scale: '1.1',
      },
    },
  },
};

const useStyles = createUseStyles({
  '@global': {
    'html, body': {
      height: '100%',
      margin: 0,
      padding: 0,
      overflow: 'hidden',
    },
  },
  ...prodAdPreviewStyle,
});

const Carousel:React.FunctionComponent<CarouselProps> = (props) => {
  const { children } = props;
  const classes = useStyles();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [length, setLength] = useState(children.length);

  // Set the length to match current children from props
  useEffect(() => {
    setLength(children.length);
  }, [children]);

  const next = () => {
    if (currentIndex < (length - 1)) {
      setCurrentIndex((prevState) => prevState + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevState) => prevState - 1);
    }
  };

  return (
    <div className={classes.carouselContainer}>
      <div className="carousel-wrapper">
        {
                    currentIndex > 0
                    && (
                    <button onClick={prev} className="left-arrow">
                      &lt;
                    </button>
                    )
                }
        <div
          className="carousel-content-wrapper"
        >
          <div
            className="carousel-content"
            style={{ transform: `translateX(-${currentIndex * 40}%)` }}
          >
            {children}
          </div>
        </div>
        {
                    currentIndex < (length / 2 - 1)
                    && (
                    <button onClick={next} className="right-arrow">
                      &gt;
                    </button>
                    )
                }
      </div>
    </div>
  );
};

export const VerticalCarousel:React.FunctionComponent<any> = (props) => {
  const { shownAds } = props;
  const classes = useStyles();

  // eslint-disable-next-line react/jsx-props-no-spreading
  const adsLayout = shownAds.map((ad: AdsCustomMessageProps) => <ProdAdPlacementCardPreview {...ad} />);

  return (
    <>
      <div className={classes.adsLabel}>
        Ads
      </div>
      <div className={classes.mainContainer}>
        <div style={{ maxWidth: 680 }}>
          <Carousel>
            {adsLayout}
          </Carousel>
        </div>
        {/* <div className='feed-back'>
          <IconButton style={likeButtonStyle} iconProps={{ iconName: 'Like' }} title="Like" ariaLabel="Like" checked={liked} onClick={onLike} />
          <IconButton style={disLikeButtonStyle} iconProps={{ iconName: 'Dislike' }} title="Dislike" ariaLabel="Dislike" checked={disliked} onClick={onDislike} />
        </div> */}
      </div>
    </>
  );
};
